<template>
  <div
    :class="[
      'transferToBank',
      isTransferNumberKeyboard ? 'isTransferNumberKeyboard' : ''
    ]"
  >
    <div class="custom-title">
      <img
        v-if="bankNo"
        class="svg-icon"
        :src="getIconByCode(bankNo)"
        alt="bank-icon"
      >
      {{ bankShortName }}
    </div>

    <div class="sub-title">Account Info</div>
    <p>{{ accountName }}</p>
    <p>{{ accountNo }}</p>

    <!-- 金额键盘和输入框 -->
    <FinancialNumberKeyboard
      v-model="money"
      :placeholder="$t('Enter Transfer Amount')"
      :error.sync="moneyErrorMessage"
      maxlength="12"
    />

    <!-- 备注 -->
    <div class="sub-title">Remark</div>
    <md-field>
      <md-input-item v-model="note" :placeholder="$t('Enter transfer')" />
    </md-field>

    <div class="transfer-button">
      <md-button
        type="primary"
        :inactive="submitActive"
        @click="transferBankHandel"
      >
        {{ $t('Submit') }}
      </md-button>
    </div>
    <!-- 支付键盘 -->
    <PasswordPopup
      v-model="passwordVisiable"
      :code.sync="password"
      :error.sync="passwordError"
      @finished="confirmMethod"
    />
    <!-- 控制支付loading -->
    <PayLoading :is-show="isShow" />
  </div>
</template>

<script>
import { InputItem, Field, Toast, Button, CellItem, NumberKeyboard } from 'mand-mobile'
import FinancialNumberKeyboard from '@/components/FinancialNumberKeyboard'
import PasswordPopup from '@/components/PasswordPopup'
import PayLoading from '@/components/PayLoading'
import { transfer, tradeDetail } from '@/api/transfer'
import { limitAmount, walletAll } from '@/api/withdraw'
import { TRADE_TITLE, ERROR_REQ_CODE, TRANSACTION_STATUS } from '@/constants'
import { formatAmount } from '@/utils/format-amount'
import fenToYuan from '@/utils/fen-to-yuan'
import yuanToFen from '@/utils/yuan-to-fen'
import { getIconByCode } from '@flash/fin-logo'
export default {
  name: 'TransferToBankConfirmInformation',
  components: {
    [InputItem.name]: InputItem,
    [Field.name]: Field,
    [Button.name]: Button,
    [CellItem.name]: CellItem,
    FinancialNumberKeyboard,
    PasswordPopup,
    PayLoading,
    [NumberKeyboard.name]: NumberKeyboard
  },
  data () {
    return {
      getIconByCode,
      money: '', // 金额
      limitAmount: '', // 限额
      allAmount: '', // 余额
      moneyErrorMessage: '', // 金额错误信息
      isTransferNumberKeyboard: false,
      inactive: true, // 转账按钮
      passwordVisiable: false, // 控制支付键盘
      password: '', // 支付密码
      passwordError: '', // 支付错误信息
      isShow: false, // loading显示
      note: '' // 备注
    }
  },
  computed: {
    submitActive () {
      const {
        money,
        moneyErrorMessage,
        isShow
      } = this
      return (
        !(
          !moneyErrorMessage &&
          money
        ) || isShow
      )
    },
    bankNo () {
      return this.$route.query.bankNo || ''
    },
    bankShortName () {
      return this.$route.query.bankShortName || ''
    },
    accountNo () {
      return this.$route.query.accountNo || ''
    },
    accountName () {
      return this.$route.query.accountName || ''
    }
  },
  watch: {
    money (money) {
      this.moneyErrorMessage = ''
      const { limitAmount, allAmount } = this
      console.log('money', money, limitAmount, allAmount)
      if (limitAmount && +money > limitAmount) {
        // 金额大于限额
        this.moneyErrorMessage = `${this.$t('less_amount_message')}${formatAmount(
          limitAmount
        )}`
      }
      if (+money > allAmount) {
        // 金额大于余额
        this.moneyErrorMessage = `${this.$t('less_amount_message')}${formatAmount(
          allAmount
        )}`
      }
    }
  },
  mounted () {
    this.getLimitAmount()
    this.getAllAmount()
  },
  destroyed () {
    this.clearInterval()
  },
  methods: {
    async getLimitAmount () {
      // 获取限额的金额
      const data = await limitAmount({
        payProductCode: TRADE_TITLE.TransferToBank
      })
      this.limitAmount = fenToYuan(data.limitAmount)
    },
    async getAllAmount () {
      // 卡里余额
      const data = await walletAll()
      this.allAmount = fenToYuan(data.balance)
    },
    transferBankHandel () {
      this.passwordVisiable = true // 密码键盘弹起
    },
    async confirmMethod (password) {
      try {
        this.isShow = true // 支付loading弹起
        this.passwordVisiable = false // 密码键盘隐藏
        this.inactive = true // 充值按钮置灰
        const {
          bankNo,
          money,
          note,
          accountNo,
          accountName
        } = this
        const { tradeNo } = await transfer({
          accountType: 1,
          password,
          amount: yuanToFen(money),
          bankNo,
          note,
          payeeAccountNo: accountNo,
          payeeName: accountName
        })
        this.tradeNo = tradeNo // 定时器中用到的参数
        this.createInterval()
      } catch (e) {
        this.isShow = false
        this.passwordVisiable = false // 键盘隐藏
        this.inactive = false // 充值高亮
        if (e.code === ERROR_REQ_CODE.passError) {
          // 密码错误
          this.passwordVisiable = true // 键盘显示
          this.passwordError = e.message
        } else {
          e.code && Toast.failed(e.message, 4000, null, document.body, true)
        }
      }
    },
    async queryTradeDetail (tradeNo, countdown) {
      const { status } = await tradeDetail({ tradeNo }, (cancel) => {
        this.peddingCancel = cancel
      })
      // 交易订单状态 0:等待交易 1:银行受理中 2:银行处理中 3:交易成功 4:交易失败 5:超时交易关闭
      if (
        status === TRANSACTION_STATUS.pend ||
        status === TRANSACTION_STATUS.pending
      ) {
        // 银行受理中、银行处理中5S内继续请求
        this.peddingCancel = false
        if (countdown === 0) {
          // 5S内继续请求完后结果还是银行受理中或者银行处理中跳转到等待处理页面
          this.isShow = false
          this.$router.replace({
            name: 'HaveNoStepsDetail',
            query: { tradeNo, path: 'TransferToBank' }
          })
        }
      } else {
        // 清除定时器
        this.clearInterval()
        this.isShow = false
        this.$router.replace({
          name: 'HaveNoStepsDetail',
          query: { tradeNo, path: 'TransferToBank' }
        })
      }
    },
    clearInterval () {
      if (this.peddingCancel) {
        this.peddingCancel() // 终止请求
      }
      clearInterval(this.timer)
    },
    createInterval () {
      let countdown = 4
      const time = 1000
      this.timer = setInterval(() => {
        if (countdown <= 0) {
          this.isShow = false
          this.clearInterval()
        } else if (!this.peddingCancel) {
          countdown--
          this.queryTradeDetail(this.tradeNo, countdown)
        }
      }, time)
    }
  }
}
</script>

<style lang="scss" scoped>
.isTransferNumberKeyboard {
  position: relative;
  bottom: 100px;
}

.transferToBank {
  display: flex;
  flex-direction: column;
  padding: 0 46px;
  height: 100%;

  .custom-title {
    display: flex;
    align-items: center;
    background-color: rgb(249, 251, 252);
    padding: 30px 0;
    margin-top: 30px;

    .svg-icon {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      margin-right: 16px;
    }
  }

  .sub-title {
    padding: 40px 0 10px;
  }

  .bank_info {
    background: #fff;
    border-radius: 32px;
    box-shadow: 0 8px 32px 0 rgba(138, 149, 158, 0.2);
    margin-top: 62px;
    padding: 24px 44px;

    .bank_info_name {
      margin-top: 24px;
      color: #b2b2b2;
      font-size: 24px;

      div:nth-child(2) {
        color: #333;
        font-size: 28px;
      }
    }

    .bank_info_footer {
      margin-bottom: 24px;
    }
  }
}

.right_tig {
  display: flex;
  flex-direction: row;
  margin: 0 16px;
  justify-content: center;
  align-items: center;
}

.icon_svg {
  width: 48px;
  height: 48px;
  border-radius: 100%;
}

.nav_svg {
  width: 50px;
  height: 36px;
}

.md-field {
  padding: 0;
}
/* stylelint-disable selector-pseudo-element-no-unknown */
::v-deep .md-field-item-content::before {
  z-index: 0;
}

::v-deep .md-input-item.is-title-latent .md-input-item-input {
  padding-left: 0;
}

.transfer-button {
  margin-top: 200px;
  padding-bottom: 200px;
}
</style>
